module.exports = __webpack_public_path__ + "media/images/xpass/icons/filter-6cf52de64ff7fce1db1384e65809612b.svg";